import asyncActionTypes from '../actions/types'; 

const initialState = {
  infoPopUp: [],
};

const PopUpPersonalization = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.START:
    case asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.FAIL:
      return {
        ...state,
        infoPopUp: [],
      };
    case asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.SUCCESS:
      return {
        ...state,
        infoPopUp : action.payload,
      }; 
    default:
      return state;
  }
};

export default PopUpPersonalization;